import { render, staticRenderFns } from "./TheOrgDashboard.vue?vue&type=template&id=71a73b72&scoped=true&"
import script from "./TheOrgDashboard.vue?vue&type=script&lang=js&"
export * from "./TheOrgDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TheOrgDashboard.vue?vue&type=style&index=0&id=71a73b72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a73b72",
  null
  
)

export default component.exports